import type { ReactNode } from 'react';

interface BackdropProps {
  readonly className?: string;
  readonly children: ReactNode;
}

export function Backdrop({ className, children }: BackdropProps) {
  return (
    <div className="relative isolate min-h-screen overflow-x-clip bg-cream">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 -z-10 bg-doodles [mask-image:radial-gradient(ellipse_70%_60%_at_50%_38%,transparent_35%,black_100%)]"
      />
      <div className={className}>{children}</div>
    </div>
  );
}
